import { Icon, type IconProps } from "@/components/ui/icon";
import * as React from "react";

export function RepoWizardIcon(props: IconProps) {
  const clipId = React.useId();
  return (
    <Icon {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M21.5163 22.4549C15.5766 16.5152 9.79772 10.7363 9.69558 10.6342C9.69344 10.632 9.69322 10.6364 9.69244 10.6394L7.95892 17.1089"
          stroke="currentColor"
          strokeWidth="1.03177"
          strokeLinecap="round"
        />
        <path
          d="M6.32619 16.6715L8.0572 10.2112C8.05798 10.2083 8.05531 10.2056 8.0524 10.2064L1.67233 11.916"
          stroke="currentColor"
          strokeWidth="1.03177"
          strokeLinecap="round"
        />
        <path
          d="M17.3283 7.58102L10.9482 9.29055C10.9453 9.29133 10.9443 9.29497 10.9464 9.29711L22.9296 21.2802"
          stroke="currentColor"
          strokeWidth="1.03177"
          strokeLinecap="round"
        />
        <path
          d="M12.2357 1.14761L10.5262 7.52768C10.5254 7.53059 10.5281 7.53326 10.531 7.53248L16.8186 5.84773"
          stroke="currentColor"
          strokeWidth="1.03177"
          strokeLinecap="round"
        />
        <path
          d="M4.16908 2.40873L8.83961 7.07927C8.84175 7.08141 8.84539 7.08043 8.84617 7.07751L10.5557 0.697442"
          stroke="currentColor"
          strokeWidth="1.03177"
          strokeLinecap="round"
        />
        <path
          d="M1.25492 10.0686L7.63499 8.35908C7.63791 8.3583 7.63889 8.35466 7.63675 8.35252L2.96622 3.68199"
          stroke="currentColor"
          strokeWidth="1.03177"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}